import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PeerJsSliceType {
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
  isScreenSharing: boolean;
  isRemoteMuted: boolean;
  peer_id: string;
  room_id: string;
  call_id: number;
  chat_id: string;
  /**
   * True only after caller starts or callee taps Accept.
   * Incoming ring sets call_id but NOT joined — avoids auto LiveKit + green bar.
   */
  call_joined: boolean;
}

const initialCallType =
  typeof window !== "undefined" ? sessionStorage.getItem("call_type") : null;

const initialState: PeerJsSliceType = {
  isVideoEnabled: initialCallType === "video",
  isAudioEnabled: true,
  isScreenSharing: false,
  isRemoteMuted: false,
  peer_id: "",
  room_id: sessionStorage.getItem("room_id") || "",
  call_id: Number(sessionStorage.getItem("call_id") || 0),
  chat_id: sessionStorage.getItem("chat_id") || "",
  call_joined:
    typeof window !== "undefined" &&
    sessionStorage.getItem("call_joined") === "true",
};

const peerJsSlice = createSlice({
  name: "PeerJsSlice",
  initialState,
  reducers: {
    
    updatePeerData(state, action: PayloadAction<Partial<PeerJsSliceType>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { updatePeerData } = peerJsSlice.actions;
export default peerJsSlice.reducer;
